<script>

export default {
  name: "ManageTransfers",
  data() {
    return {
      transfers: [],
      departments: [],
      search: ''

    }
  },
  computed: {
    sidebarData() {
      return this.$store.getters['sidebarData'];
    },
    filteredTransfers() {
      if (!this.search) {
        return this.transfers;
      }
      return this.transfers.filter(transfer =>
          transfer.code.toString().includes(this.search.toLowerCase())
      );
    }
  },
  methods: {
    async getTransfers() {
      try {
        let result = await this.$api.get("/auth/transfers");
        if (result.status.toString() === "200") {
          this.transfers = result.data
          if (this.transfers === null) {
            this.transfers = ''
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la información',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getDepartments() {
      try {
        let res = await this.$api.get("/auth/departments");
        if (res.status.toString() === "200") {
          this.departments = res.data
        }
      } catch (error) {
        console.log("can't get departments data")
      }
    },
    async ShowTransfer(id) {
      this.$router.push({name: 'ShowTransfer', params: {id: id}})
    },
  },
  created() {
    this.getTransfers()
    this.getDepartments()
  }

}
</script>

<template>
  <div id="section-0" class="container">

    <div class="userSearch">
      <h1>Transferencias</h1>

      <div class="subOpt">
        <input type="text" v-model="search"
               placeholder="Buscar por fecha ...">
        <button role="link" @click="$router.push('/scene/register_transfer')">Registrar nueva transferencia</button>
      </div>


      <div class="table-container mt-4" v-if="transfers.length">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>#</th>
            <th>Codigo</th>
            <th>Fecha</th>
            <th>Opciones</th>


          </tr>

          </thead>
          <tbody>

          <tr v-for="(transfer, index) in filteredTransfers" :key="transfer.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{transfer.id}}</td>
            <td>{{ transfer.createdAt.substring(0, 10) +" "+ transfer.createdAt.substring(11, 19) }}</td>
            <td class="td_align_center">
              <button class="tableBtn" @click="this.ShowTransfer(transfer.id)" role="link">Ver</button>
            </td>
          </tr>

          </tbody>

        </table>
      </div>
      <div v-else>
        <p class="bordered-p">No hay transferencias disponibles.</p>
      </div>


    </div>
  </div>


</template>


<style>

.subOpt {
  grid-template-columns: 1fr 1fr;
  display: grid;
  justify-content: space-between;
  gap: 20px;
  width: 800px;
  margin: auto;
}

</style>